import * as ajaxService from './ajax-service';

export class FavoritesService {
    state = Vue.observable({
        favoritesData: { ...window.specialtyApp.initialFavoriteState },
    });

    // eslint-disable-next-line class-methods-use-this
    addToFavorites(product) {
        return ajaxService.post('/api/favorite/add/', {
            data: {
                product,
            },
        }).then(() => {
            this.getAllFavorites();
        });
    }

    // eslint-disable-next-line class-methods-use-this
    removeFromFavorites(product) {
        return ajaxService.post('/api/favorite/delete/', {
            data: {
                product,
            },
        }).then(() => {
            this.getAllFavorites();
        });
    }

    // eslint-disable-next-line class-methods-use-this
    isFavoriteAdded(id) {
        return ajaxService.get(`/api/favorite/get/${id}/`, {});
    }

    // eslint-disable-next-line class-methods-use-this
    getAllFavorites() {
        return ajaxService.get('/api/favorite/list/', {}).then((response) => {
            const { data: { data: favoritesData } } = response;
            this.setFavoritesData(favoritesData);
            return response;
        });
    }

    setFavoritesData(favoritesData) {
        Vue.set(this.state, 'favoritesData', Vue.observable(favoritesData));
    }
}
